<template>
  <v-container fluid>
    <HeaderLabel class="mb-2" title="Setting" :show-back-button="false" />
    <!-- <v-card>
      <v-card-title>
        <span class="headline">System Configuration</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <ServiceProductManager
              @error="handleServiceProductError"
              @success="handleServiceProductSuccess"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card> -->
    <div class="custom-container-box">
      <ServiceProductManager
        @error="handleServiceProductError"
        @success="handleServiceProductSuccess"
      />

      <v-divider class="my-5"></v-divider>

      <QAManager @error="handleServiceProductError" @success="handleServiceProductSuccess" />
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { get } from 'lodash';
import ServiceProductManager from '@/components/ClinicProfile/ServiceProductManager';
import QAManager from '@/components/SystemConfig/QAManager';
import HeaderLabel from '@/components/customFormLabel/headerLabel.vue';
export default {
  name: 'SystemConfig',
  components: {
    ServiceProductManager,
    QAManager,
    HeaderLabel,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['debug']),
  },
  async mounted() {},
  methods: {
    get,
    ...mapActions('alert', ['updateAlertMessage']),

    handleServiceProductError(message) {
      this.updateAlertMessage({
        msg: message,
        type: 'error',
      });
    },

    handleServiceProductSuccess(message) {
      this.updateAlertMessage({
        msg: message,
        type: 'success',
        color: 'success',
      });
    },
  },
};
</script>

<style scoped>
textarea {
  font-family: monospace;
  background-color: #fafafa;
  width: 100%;
  min-height: 300px;
}
</style>
